(function () {
    window.addEventListener('load', function () {
        initNormalSlider();
        initPostsSlider();
        initTimelineSlider();
        initProductThumbsSlider();
        initPicSliderGalleryBlock();
    });

    function initPicSliderGalleryBlock() {
        let sliders = document.querySelectorAll('[data-gallery-slider]');

        if( sliders.length ) {
            sliders.forEach(function(elem) {

                let slider = tns({
                    container: elem,
                    items: 2,
                    slideBy: 1,
                    mode: 'carousel',
                    autoplay: false,
                    nav: false,
                    autoplayButtonOutput: false,
                    speed: 800,
                    loop: false,
                    center: false,
                    gutter: 15,
                    responsive: {
                        600: {
                            items: 3,
                            gutter: 30,
                        },
                    }
                });

            })
        }
    }
    function initNormalSlider() {
        let sliders = document.querySelectorAll('[data-slider]');
        if( sliders.length ) {
            sliders.forEach(function(elem) {
                let slider = tns({
                    container: elem,
                    items: 1,
                    slideBy: 1,
                    mode: 'carousel',
                    autoplay: false,
                    nav: true,
                    autoplayButtonOutput: false,
                    speed: 800,
                    prevButton: false,
                    nextButton: false
                });


                let prevButtons = elem.querySelectorAll('[data-navigation="prev"]');
                let nextButtons = elem.querySelectorAll('[data-navigation="next"]');

                if( prevButtons.length ) {
                    prevButtons.forEach(function(button) {
                        button.addEventListener('click', function() {
                            slider.goTo('prev');
                        })
                    })
                }

                if (nextButtons.length ) {
                    nextButtons.forEach(function(button) {
                        button.addEventListener('click', function() {
                            slider.goTo('next');
                        })
                    })
                }
            });

        }
    }

    function initPostsSlider() {
        let postsSliders = document.querySelectorAll('[data-posts-slider]');
        if( postsSliders.length ) {
            postsSliders.forEach(function(elem) {
                let slider = tns({
                    container: elem,
                    items: 1,
                    slideBy: 1,
                    mode: 'carousel',
                    autoplay: false,
                    nav: false,
                    autoplayButtonOutput: false,
                    speed: 800,
                    loop: false,
                    responsive: {
                        600: {
                            items: 2,
                            gutter: 25
                        },
                        1200: {
                            items: 3,
                            gutter: 40
                        },
                    }
                });


                let prevButtons = elem.querySelectorAll('[data-navigation="prev"]');
                let nextButtons = elem.querySelectorAll('[data-navigation="next"]');

                if( prevButtons.length ) {
                    prevButtons.forEach(function(button) {
                        button.addEventListener('click', function() {
                            slider.goTo('prev');
                        })
                    })
                }

                if (nextButtons.length ) {
                    nextButtons.forEach(function(button) {
                        button.addEventListener('click', function() {
                            slider.goTo('next');
                        })
                    })
                }
            });
        }
    }


    function initTimelineSlider() {
        let sliderWrapper = document.querySelectorAll('[data-timeline-slider]');

        if (sliderWrapper.length ) {
            sliderWrapper.forEach(function(elem) {
                let slidesCount = elem.querySelectorAll('.timeline__slide').length -1;

                let slider = tns({
                    container: elem,
                    items: 5,
                    slideBy: 2,
                    mode: 'carousel',
                    autoplay: false,
                    nav: true,
                    autoplayButtonOutput: false,
                    speed: 800,
                    loop: false,
                    center: false,
                    startIndex: slidesCount,
                    responsive: {
                        1200: {
                            items: 7,
                            gutter: 40
                        },
                    }
                });


                let prevButtons = elem.querySelectorAll('[data-navigation="prev"]');
                let nextButtons = elem.querySelectorAll('[data-navigation="next"]');
                let slides = elem.querySelectorAll('.timeline__slideInner');

                if( prevButtons.length ) {
                    prevButtons.forEach(function(button) {
                        button.addEventListener('click', function() {
                            slider.goTo('prev');
                        })
                    })
                }

                if (nextButtons.length ) {
                    nextButtons.forEach(function(button) {
                        button.addEventListener('click', function() {
                            slider.goTo('next');
                        })
                    })
                }

                if ( slides.length ) {
                    slides.forEach(function(item) {
                        item.addEventListener('click', function() {
                            elem.querySelector('.timeline__slideInner.active').classList.remove('active');
                            this.classList.add('active');

                            document.querySelector('.wp-block-columns.active').classList.remove('active');
                            document.querySelector('.wp-block-columns[data-index="'+ this.getAttribute('data-index') +'"]').classList.add('active');
                        })
                    })
                }
            });
        }
    }

    function initProductThumbsSlider() {
        let sliderWrapper = document.querySelectorAll('[data-product-thumbs]');

        if (sliderWrapper.length ) {
            sliderWrapper.forEach(function(elem) {
                let slider = tns({
                    container: elem,
                    items: 2,
                    slideBy: 1,
                    mode: 'carousel',
                    autoplay: false,
                    nav: false,
                    autoplayButtonOutput: false,
                    speed: 800,
                    loop: false,
                    center: false,
                    gutter: 15,
                    responsive: {
                        600: {
                            items: 3,
                        },
                        768: {
                            items: 4,
                        },
                    }
                });


                let prevButtons = elem.querySelectorAll('[data-navigation="prev"]');
                let nextButtons = elem.querySelectorAll('[data-navigation="next"]');

                if( prevButtons.length ) {
                    prevButtons.forEach(function(button) {
                        button.addEventListener('click', function() {
                            slider.goTo('prev');
                        })
                    })
                }

                if (nextButtons.length ) {
                    nextButtons.forEach(function(button) {
                        button.addEventListener('click', function() {
                            slider.goTo('next');
                        })
                    })
                }
            });
        }
    }
})()


//////////////////
// WEBPACK FOOTER
// ./js/modules/slider.js
// module id = 10
// module chunks = 0